import { Box, SxProps } from '@modusign/design-system';
import { ButtonHTMLAttributes, useMemo } from 'react';

import { ArrowIcon } from '@app/components/Icons';

interface ArrowButtonProps extends SxProps, ButtonHTMLAttributes<HTMLButtonElement> {
  direction: 'bottom' | 'left' | 'right' | 'top';
}

const defaultProps = {
  direction: 'right' as const,
};

function ArrowButton({ direction, disabled, sx, ...props }: ArrowButtonProps) {
  const rotateDegree = useMemo(() => {
    switch (direction) {
      case 'bottom':
        return 90;
      case 'left':
        return 180;
      case 'top':
        return 270;
      default:
        return 0;
    }
  }, [direction]);

  return (
    <Box
      {...props}
      as="button"
      disabled={disabled}
      sx={{
        border: '1px solid',
        borderColor: 'lightGray300',
        height: 32,
        width: 36,
        '&:disabled': {
          cursor: 'not-allowed',
        },
        '&:hover': {
          backgroundColor: 'lightGray50',
        },
        ...sx,
      }}
      type="button"
    >
      <Box sx={{ transform: direction !== 'right' ? `rotate(${rotateDegree}deg)` : undefined }}>
        <ArrowIcon color={disabled ? 'gray' : 'black'} />
      </Box>
    </Box>
  );
}

ArrowButton.defaultProps = defaultProps;

export default ArrowButton;
